import React, { useState } from 'react';
import EmailSubscriptionsTableRow from './EmailSubscriptionTableRow';
import type { Subscription } from '../../../../types';

type Props = {
  subscriptions?: Array<Subscription>,
  onUpdateEmailSubscriptions: (subscriptions: any[]) => void
};

const EmailSubscriptionsTableContent = ({ subscriptions, onUpdateEmailSubscriptions }: Props) => {
  const [emailSubscriptions, setEmailSubscriptions] = useState<{ [key: number]: Subscription }>({});

  const handleSubscriptionChange = (updatedSubscription: Subscription) => {
    setEmailSubscriptions(prev => ({
      ...prev,
      [updatedSubscription.id]: updatedSubscription
    }));
  };

  return (
    <div className="container main-content subscriptions-table">
      <div className="table-navbar" style={{ fontSize: '14px' }}>
        <div className="table-column">User name</div>
        <div className="table-column">New Client Registered</div>
        <div className="table-column">Reaching Monthly Limit</div>
        <div className="table-column">Monthly Limit Changed</div>
        <div className="table-column">New Vacation Added</div>
        <div className="table-column">Weekly Projects Report</div>
      </div>
      <div className="table-rows">
        {(subscriptions || []).map(subscription => (
          <EmailSubscriptionsTableRow key={subscription.id} emailSubscription={subscription} onSubscriptionChange={handleSubscriptionChange} />
        ))}
      </div>
      <button
        className="add-btn"
        type="button"
        onClick={() => onUpdateEmailSubscriptions(Object.values(emailSubscriptions))}
      >
        Submit
      </button>
    </div>
  );
};

export default EmailSubscriptionsTableContent;
